import type { GetServerSideProps, NextPage } from 'next';
import { Frontpage } from '@/components/FrontPage';
import { verticalConfig } from '@/config/verticalConfig';
import { createSspForVertical, type SspProps } from '@/util/verticalSsp';

const FrontPageCar: NextPage<SspProps> = (pageProps) => <Frontpage config={verticalConfig.carrental} {...pageProps} />;

export const getServerSideProps: GetServerSideProps<SspProps> = createSspForVertical(verticalConfig.carrental.vertical);

export default FrontPageCar;
